/* SerranoMarkt | BTS ready-set offer and init | QA only */
(() => {
  'use strict';
  const B = window.SerranoBtsSecondBox;
  if (!B || !B.enhanceBuilder || B.readyInit) return;
  B.readyInit = true;

  const currentVariantId = (marker) => {
    const scope = marker.parentElement || document;
    const selector = scope.querySelector('form[data-product-form] [name="id"]') || scope.querySelector('form[action*="/cart/add"] [name="id"]');
    return B.numericId(selector?.value || marker.dataset.btsVariantId);
  };
  const seedFrom = (marker) => ({
    variantId: currentVariantId(marker),
    price: B.number(marker.dataset.btsPrice),
    pack: B.number(marker.dataset.btsPackSize),
    title: marker.dataset.btsTitle || 'Daily Nuuds kutusu'
  });
  const enhanceReady = (marker) => {
    if (!marker || marker.dataset.btsReadyEnhanced === 'true') return;
    const scope = marker.parentElement;
    const action = scope?.querySelector('.serrano-product-actions') || scope?.querySelector('.add-to-cart-btn')?.parentElement;
    if (!scope || !action) return;
    const seed = seedFrom(marker);
    if (!seed.variantId || !seed.price || !seed.pack) return;
    marker.dataset.btsReadyEnhanced = 'true';
    const offer = document.createElement('div');
    offer.className = 'bts2-ready-offer';
    offer.innerHTML = `<button type="button" class="bts2-ready-trigger" aria-expanded="false"><span class="bts2-ready-trigger__eyebrow">BACK TO SCHOOL</span><strong class="bts2-ready-trigger__title" data-bts2-title>2 KUTUYU BİRLİKTE EKLE</strong><small class="bts2-ready-trigger__price">İndirimli 2. kutuda ${B.discountedUnitText(seed.price, seed.pack)}</small></button><div class="bts2-ready-choices" hidden><div class="bts2-ready-choices__header"><div><strong>İKİNCİ KUTUNU SEÇ</strong><small>İki kutu tek seferde sepete eklenecek.</small></div><button type="button" class="bts2-ready-close">Kapat</button></div><div class="bts2-ready-choices__options"><button type="button" class="bts2-ready-choice bts2-ready-choice--same" data-bts-ready-same><strong>AYNI KUTUDAN BİR TANE DAHA</strong><span>Bu hazır kutudan iki adet ekle.</span></button><button type="button" class="bts2-ready-choice" data-bts-ready-custom><strong>2. KUTUYU KENDİM OLUŞTURACAĞIM</strong><span>Aşağıdaki kutu oluşturucuya geç.</span></button></div><p class="bts2-ready-status" data-bts-ready-error role="alert"></p></div>`;
    action.after(offer);
    const trigger = offer.querySelector('.bts2-ready-trigger');
    const choices = offer.querySelector('.bts2-ready-choices');
    const errorNode = offer.querySelector('[data-bts-ready-error]');
    const close = () => { choices.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
    trigger.addEventListener('click', () => {
      choices.hidden = !choices.hidden;
      trigger.setAttribute('aria-expanded', choices.hidden ? 'false' : 'true');
      if (!choices.hidden) B.scrollTo(choices);
    });
    offer.querySelector('.bts2-ready-close')?.addEventListener('click', close);
    offer.querySelector('[data-bts-ready-same]')?.addEventListener('click', async (event) => {
      const current = seedFrom(marker);
      await B.addItems({
        items: [B.readyLine(current, 1), B.readyLine(current, 2)], button: event.currentTarget, errorNode,
        tracking: { mode: 'ready_same', firstPack: current.pack, secondPack: current.pack, estimatedTotal: B.estimatedPairTotal(current.price, current.price) / 100 }
      });
    });
    offer.querySelector('[data-bts-ready-custom]')?.addEventListener('click', () => {
      const builder = [...document.querySelectorAll('dn-home-box-builder')].find((candidate) => candidate.dataset.btsSecondBuilder !== 'true');
      if (!builder) {
        errorNode.textContent = 'Bu sayfada kutu oluşturucu bulunamadı.';
        return;
      }
      close();
      B.activateExternalSeed(builder, seedFrom(marker));
    });
  };
  const run = () => {
    if (!window.customElements) return;
    customElements.whenDefined('dn-home-box-builder').then(() => {
      document.querySelectorAll('dn-home-box-builder').forEach(B.enhanceBuilder);
      document.querySelectorAll('[data-bts-ready-pdp]').forEach(enhanceReady);
    }).catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', () => setTimeout(run, 0));
  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === Node.ELEMENT_NODE && (node.matches?.('dn-home-box-builder,[data-bts-ready-pdp]') || node.querySelector?.('dn-home-box-builder,[data-bts-ready-pdp]'))));
    if (relevant) setTimeout(run, 0);
  });
  const start = () => observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
